import { ClassificationType } from '@/types/classification';
import { CNIPA_EXAMPLES, EPO_EXAMPLES, USPTO_EXAMPLES } from '../constants/specification-create';
import { SpecificationJurisdiction, type SpecificationParagraphContentType } from '../enums';
import type { SpecificationCreateExample } from '../types/specification-task-create';
import { SpecificationContentTypeLabelCNIPAM, SpecificationContentTypeLabelEPO, SpecificationContentTypeLabelUSPTO, SpecificationGenContentTitleMaxLengthCNIPAM, SpecificationGenContentTitleMaxLengthEPO, SpecificationGenContentTitleMaxLengthUSPTO, FigurePrefixCNIPAM, FigurePrefixUSPTO, FigurePrefixEPO } from '../constants/specification-gen-content';

/**
 * 获取用户输入示例
 * 根据选择的受理局，获取对应的示例，
 * 如果受理局为空，则返回空数组
 */
export function getCreateExamples(jurisdiction: SpecificationJurisdiction): SpecificationCreateExample[] {
    if (jurisdiction === SpecificationJurisdiction.US) {
        return USPTO_EXAMPLES;
    } else if (jurisdiction === SpecificationJurisdiction.EU) {
        return EPO_EXAMPLES;
    }
    return CNIPA_EXAMPLES;
}

/**
 * 获取分类类型
 * 根据选择的受理局，获取对应的分类类型
 * 默认 ClassificationType.IPC
 */
export function getClassificationType(jurisdiction: SpecificationJurisdiction | null | undefined): ClassificationType {
    return jurisdiction === SpecificationJurisdiction.CN ? ClassificationType.IPC : ClassificationType.CPC;
}


/**
 * 获取说明书标题最大字数
 * 根据选择的受理局，获取对应的说明书标题最大字数
 */
export function getSpecificationTitleMaxLength(jurisdiction: SpecificationJurisdiction | null | undefined): number {
    if (jurisdiction === SpecificationJurisdiction.CN) {
        return SpecificationGenContentTitleMaxLengthCNIPAM;
    } else if (jurisdiction === SpecificationJurisdiction.EU) {
        return SpecificationGenContentTitleMaxLengthEPO;
    }
    return SpecificationGenContentTitleMaxLengthUSPTO;
}

/**
 * 获取说明书段落标签
 * 根据选择的受理局和段落类型，获取对应的段落标签
 * @param jurisdiction 受理局
 * @param contentType 段落类型
 */
export function getSpecificationContentTypeLabel(jurisdiction: SpecificationJurisdiction | null, contentType: SpecificationParagraphContentType): string {
    if (jurisdiction === SpecificationJurisdiction.CN) {
        return SpecificationContentTypeLabelCNIPAM[contentType] || '';
    } else if (jurisdiction === SpecificationJurisdiction.EU) {
        return SpecificationContentTypeLabelEPO[contentType] || '';
    }
    return SpecificationContentTypeLabelUSPTO[contentType] || '';
}

/**
 * 获取图片序号前缀
 * 根据选择的受理局，获取对应的图片序号前缀
 * @param jurisdiction 受理局
 */
export function getFigurePrefix(jurisdiction: SpecificationJurisdiction | null): string {
    if (jurisdiction === SpecificationJurisdiction.CN) {
        return FigurePrefixCNIPAM;
    } else if (jurisdiction === SpecificationJurisdiction.EU) {
        return FigurePrefixEPO;
    }
    return FigurePrefixUSPTO;
}


/**
 * 获取不同受理局的实施例类型
 * @param jurisdiction 受理局
 */
export function getSpecificationEmbodimentTypes(jurisdiction: SpecificationJurisdiction | null): string[] {
    if (jurisdiction === SpecificationJurisdiction.CN) {
        return ['设备', '产品', '方法', '材料'];
    }
    return ['Procesee', 'Composition', 'Machine', 'Manufacture'];
}
